import React, { Component } from 'react';
import { connect } from 'react-redux';
import './form.css';

class scheduleForm extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
     
    };

  }

  onChangeName = (event) =>{
    var tmpData = {...this.props.data};
    tmpData.name = event.target.value;
    tmpData.type = "SCHEDULE";
    tmpData.contractId = this.props.ids.i;
    tmpData.riskId = this.props.ids.j;
    this.props.onUpdateData(tmpData);
  }



  render() {
    var data = this.props.data;
    if(data === null){
      data = {type:"SCHEDULE",name:"",riskType:"type1",contractId:this.props.ids.i};
    }

    return (
      <div className="form-container" >
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (contract id : {this.props.ids.i})</span>
            <div className="section-status unvalid"></div>
          </div>
          <div className="section-item">
            <label>Name</label>
            <input type="text" onChange={this.onChangeName.bind()} value={data.name}></input>
          </div>
        </div>
        <div className="form-section">
            <div className="section-header">
              <span className="section-name">Valeurs</span>
              <div className="section-status unvalid"></div>
            </div>
            <div className="section-item">
              <label>Schedule number</label>
              <input type="number"></input>
            </div>
          </div>
      </div>
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(scheduleForm);